import styled, { css } from 'styled-components';

import {
  grey1,
  grey2,
  grey3,
  grey7,
  grey8,
} from 'approot/shared/styles/colours.style';
import { mediaUp, rem } from 'approot/shared/style';
import {
  borderRadius8,
  standardFocusStateInset,
} from 'approot/shared/styles/borders.style';
import {
  fontSize16,
  fontSize16LineHeight,
} from 'approot/shared/styles/typography.style';
import { spacing16, spacing8 } from 'approot/shared/styles/spacing.style';
import {
  LAYOUT_HEADER_HEIGHT,
  LAYOUT_LARGE_NAVIGATION_DRAWER,
  LAYOUT_TRANSITION_DURATION,
} from '../../layout.styles';

export const navigationBaseLinkCss = css`
  border: none;
  background-color: transparent;
  border-radius: ${rem(borderRadius8)};
  color: ${grey7};
  display: flex;
  align-items: center;
  font-size: ${rem(fontSize16)};
  line-height: ${rem(fontSize16LineHeight)};
  padding: ${rem(spacing8)} ${rem(spacing16)};
  text-decoration: none;

  ${standardFocusStateInset}

  &:focus {
    color: ${grey8};
  }
  &:focus:not(:focus-visible) {
    color: ${grey7};
  }
  &:focus-visible {
    color: ${grey8};
  }

  &:hover,
  &:hover:active {
    background-color: ${grey2};
    color: ${grey8};
    cursor: pointer;

    svg {
      stroke: ${grey8};
    }
  }
`;

export const navigationDrawerBaseCss = css`
  background-color: ${grey1};
  padding-top: ${rem(LAYOUT_HEADER_HEIGHT + spacing8)};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  left: env(safe-area-inset-left);

  ${mediaUp.md`
    border-right: 1px solid ${grey3};
  `}
`;

type NavigationProps = {
  $isActive?: boolean;
};
export const NavigationDrawer = styled.nav<NavigationProps>`
  ${navigationDrawerBaseCss}

  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left);
  max-width: ${rem(360)};
  width: 100%;
  transform: translate3d(-100%, 0, 0);
  transition: all ${LAYOUT_TRANSITION_DURATION}ms
    cubic-bezier(0.65, 0.05, 0.36, 1);
  z-index: 102;

  ${mediaUp.md`
    width: ${rem(LAYOUT_LARGE_NAVIGATION_DRAWER)};
  `}

  ${mediaUp.xl`
    box-shadow: none;
    transform: translate3d(0, 0, 0);
    visibility: visible;
    z-index: 1;
  `}

  ${({ $isActive }) =>
    $isActive
      ? `
    box-shadow: 0px 8px 15px rgba(57,16,133,0.3);
    transform: translate3d(0, 0, 0);
  `
      : `
      visibility: hidden;
  `}
`;
